import { useMemo } from 'react';
import { useQueryParams } from '@hooks/queryParams';
import { useWorkflowsDropdown } from '@services/dropdowns/workflows';
import { expandWorkflowIds } from '@services/workload/calendar/hiddenRecords';

export const useWorkloadFilterParams = () => {
  const { params, searchParams } = useQueryParams();
  const workflows = useWorkflowsDropdown({});

  const searchParamsKey = searchParams.toString();
  const workflowIds = useMemo(
    () => expandWorkflowIds(params.workflowIds, workflows.data?.records || []),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParamsKey, workflows.data?.records],
  );

  const filterParams = useMemo(
    () => ({ ...params, workflowIds }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParamsKey, workflowIds],
  );

  return { filterParams, filterKey: `${searchParamsKey}|${workflowIds?.join(',') || ''}` };
};
